// Shortcodes.tsx
import React, { useState, useEffect } from 'react';
import { collection, getDocs, query, orderBy } from 'firebase/firestore';
import { Link } from 'react-router-dom';
import { useLoader } from '../../universal/context/LoaderContext';
import { useNotification } from '../../universal/context/NotificationContext';
import { dbModernCasinos } from '../../App';

interface IShortcode {
  id: string;
  createdAt: any; // Firestore timestamp or Date
  category: string;
  // Other fields as needed
}

const Shortcodes: React.FC = () => {
  const [shortcodes, setShortcodes] = useState<IShortcode[]>([]);
  const [searchText, setSearchText] = useState<string>('');
  const [selectedCategory, setSelectedCategory] = useState<string>('');
  const [categories, setCategories] = useState<string[]>([]);
  const { showLoader, hideLoader } = useLoader();
  const { showNotification } = useNotification();

  useEffect(() => {
    loadShortcodes();
    loadCategories();
  }, []);

  const loadShortcodes = async () => {
    try {
      showLoader("Loading shortcodes...");
      const qs = await getDocs(query(collection(dbModernCasinos, 'casinosets'), orderBy('createdAt', 'desc')));
      const data = qs.docs.map(doc => ({ id: doc.id, ...doc.data() })) as IShortcode[];
      setShortcodes(data);
      hideLoader();
    } catch (error: any) {
      console.error("Error loading shortcodes:", error);
      showNotification(`Error loading shortcodes: ${error.message}`, 'error');
      hideLoader();
    }
  };

  const loadCategories = async () => {
    try {
      const qs = await getDocs(collection(dbModernCasinos, 'categories'));
      const cats = qs.docs.map(doc => doc.id);
      setCategories(cats);
    } catch (error: any) {
      console.error("Error loading categories:", error);
    }
  };

  const filteredShortcodes = shortcodes.filter(sc => {
    const matchesSearch = sc.id.toLowerCase().includes(searchText.toLowerCase());
    const matchesCategory = selectedCategory ? sc.category === selectedCategory : true;
    return matchesSearch && matchesCategory;
  });

  return (
    <div className='dashpanel'>
      <div className="main">
        <div className="head">
          <div style={{ maxWidth: '1200px'}}>
            <h2>Shortcodes</h2>
            <div style={{ marginBottom: '1rem', marginTop: '1rem' }}>
              <Link 
                to="/console/shortcodes/casinolinker"
                style={{
                  backgroundColor: '#007BFF',
                  color: '#fff',
                  fontWeight: 'bold',
                  padding: '10px 15px',
                  borderRadius: '5px',
                  textDecoration: 'none'
                }}
              >
                New Casino Link
              </Link>
            </div>
            <div style={{ display: 'flex', gap: '10px', marginBottom: '1rem', maxWidth: '800px' }}>
              <input 
                type="text"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                placeholder="Search by shortcode name..."
                style={{
                  flex: 1,
                  padding: '10px',
                  borderRadius: '5px',
                  border: '1px solid #ccc',
                  fontWeight: 'bold'
                }}
              />
              <select 
                value={selectedCategory} 
                onChange={(e) => setSelectedCategory(e.target.value)}
                style={{
                  padding: '10px',
                  borderRadius: '5px',
                  border: '1px solid #ccc',
                  fontWeight: 'bold',
                  color: '#007BFF'
                }}
              >
                <option value="">All Categories</option>
                {categories.map(cat => (
                  <option key={cat} value={cat}>{cat}</option>
                ))}
              </select>
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px' }}>
              {filteredShortcodes.map(sc => (
                <div
                  key={sc.id}
                  style={{
                    border: '1px solid #ccc',
                    borderRadius: '8px',
                    padding: '1rem',
                    width: '250px',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                  }}
                >
                  <h3 style={{ margin: '0 0 0.5rem 0' }}>{sc.id}</h3>
                  <p><strong>Category:</strong> {sc.category}</p>
                  
                  {/* Edit Button */}
                  <Link
                    to={`/console/shortcodes/edit/${sc.id}`}
                    style={{
                      display: 'block',
                      marginTop: '1rem',
                      backgroundColor: '#28a745',
                      color: '#fff',
                      textAlign: 'center',
                      padding: '8px 12px',
                      borderRadius: '5px',
                      textDecoration: 'none'
                    }}
                  >
                    Edit
                  </Link>

                  {/* NEW Deploy Button */}
                  <Link
                    to={`/console/shortcodes/deploy/${sc.id}`}
                    style={{
                      display: 'block',
                      marginTop: '0.5rem',
                      backgroundColor: '#17a2b8',
                      color: '#fff',
                      textAlign: 'center',
                      padding: '8px 12px',
                      borderRadius: '5px',
                      textDecoration: 'none'
                    }}
                  >
                    Deploy
                  </Link>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Shortcodes;
